const commaSeparator = (num: string | number) => {
  if (num === null || num === undefined) {
    return ''
  }
  const str = num.toString().split('.')
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return str.join('.')
}

export default commaSeparator
